'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import GoodSubTypes from '../constants/GoodSubTypes';
import { getAlphaSortedArrOfTextValPairsForSelect } from '../utils/utils';
import { getFriendlyCategoryFilterName } from '../utils/langUtils';
var ALL_GOOD_TYPE_OPTIONS = [GoodSubTypes.EMAIL_TEMPLATES, GoodSubTypes.LANDING_PAGES, GoodSubTypes.SITE_PAGES, GoodSubTypes.BLOG_TEMPLATES, GoodSubTypes.PACKS, GoodSubTypes.UNSUBSCRIBE_SIMPLE, GoodSubTypes.ERROR_PAGE, GoodSubTypes.PASSWORD_PAGE, GoodSubTypes.SUBSCRIPTION_PREFERENCES, GoodSubTypes.UNSUBSCRIBE_CONFIRMATION, GoodSubTypes.CONTENT_SEARCH_RESULTS];

var GoodSubTypeDropdown = function GoodSubTypeDropdown(_ref) {
  var buttonClassName = _ref.buttonClassName,
      onSubTypeChange = _ref.onSubTypeChange,
      subTypeOptions = _ref.subTypeOptions,
      value = _ref.value;
  return React.createElement(UIDropdown, {
    buttonClassName: "p-all-0 " + buttonClassName,
    buttonText: getFriendlyCategoryFilterName(value),
    buttonUse: "transparent",
    placement: "bottom right"
  }, React.createElement(UITypeahead, {
    onChange: onSubTypeChange,
    options: getAlphaSortedArrOfTextValPairsForSelect(subTypeOptions || ALL_GOOD_TYPE_OPTIONS, getFriendlyCategoryFilterName, GoodSubTypes.ALL),
    value: value
  }));
};

GoodSubTypeDropdown.propTypes = {
  buttonClassName: PropTypes.string,
  onSubTypeChange: PropTypes.func.isRequired,
  subTypeOptions: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string.isRequired
};
export default GoodSubTypeDropdown;